export default __webpack_public_path__ + "static/media/radio-selected-dark.207b4136.svg";